import {Nullish} from 'shared/web';

import {getLocaleLanguageLabel} from './getLocaleLanguageLabel';

export const getLocaleLabel = (locale: string | Nullish): string | null => {
  if (!locale) {
    return null;
  }

  return `${getLocaleLanguageLabel(locale)} (${locale})`;
};
